module.exports = __webpack_public_path__ + "media/images/portugal_center/moliceiro-5e253d77058d1435dfae7c0897da1adf.jpeg";